import { BlastAtmosphere } from '../components/BlastAtmosphere'
import { Button } from '../components/Button'
import { Panel } from '../components/Panel'
import { PlayButton } from '../components/PlayButton'
import { RankEmblem } from '../components/RankEmblem'
import { rankFamilies } from '../lib/ranks'

export function TntWarsPage() {
  return (
    <main>
      <section className="hero hero--tntwars">
        <BlastAtmosphere variant="section" />
        <div className="hero__content">
          <p className="eyebrow">Modalità competitiva 1v1</p>
          <h1>
            Non è solo un minigame.
            <br />
            <span>È un sistema competitivo.</span>
          </h1>
          <p className="hero__lead">
            TNTWars su BlastCore è ingegneria balistica, posizionamento
            strategico e reazioni fulminee. Il matchmaking usa il tuo MMR reale
            per cercare avversari competitivi.
          </p>
          <div className="hero__actions">
            <PlayButton />
            <Button to="/leaderboard" variant="secondary">
              Classifiche
            </Button>
          </div>
        </div>
      </section>
      <div className="magma-separator magma-separator--quiet" aria-hidden="true" />

      <section className="section bento">
        <Panel
          className="bento__wide"
          eyebrow="ELO / MMR"
          title="Matchmaking basato sul rating"
        >
          <p className="large-copy">
            La modalità Ranked usa la formula ELO di TNTWars, placement
            stagionali e protezione anti-boost. La coda e i duelli restano
            sempre in-game.
          </p>
          <div className="data-line">
            <span>Placement richiesti</span>
            <strong>5</strong>
          </div>
          <div className="data-line">
            <span>Rating iniziale</span>
            <strong>1100 MMR</strong>
          </div>
          <div className="rating-flow" aria-label="Progressione competitiva">
            <article className="rating-flow__stage">
              <span className="rating-flow__index">01</span>
              <div className="rating-flow__signal rating-flow__signal--placement">
                <strong>5</strong>
                <i />
                <i />
                <i />
                <i />
                <i />
              </div>
              <div>
                <strong>Placement</strong>
                <span>Calibrazione iniziale</span>
              </div>
            </article>
            <span className="rating-flow__connector" aria-hidden="true" />
            <article className="rating-flow__stage">
              <span className="rating-flow__index">02</span>
              <div className="rating-flow__signal rating-flow__signal--mmr">
                <strong>MMR</strong>
                <span>↗</span>
              </div>
              <div>
                <strong>Rating live</strong>
                <span>Ogni match conta</span>
              </div>
            </article>
            <span className="rating-flow__connector" aria-hidden="true" />
            <article className="rating-flow__stage rating-flow__stage--rank">
              <span className="rating-flow__index">03</span>
              <div className="rating-flow__emblems">
                <RankEmblem rankId="bronze_3" size="small" />
                <RankEmblem rankId="silver_1" size="small" />
                <RankEmblem rankId="gold_1" size="small" />
              </div>
              <div>
                <strong>Rank</strong>
                <span>22 gradi competitivi</span>
              </div>
            </article>
          </div>
        </Panel>
        <Panel eyebrow="Gameplay" title="Funzionalità competitive">
          <ul className="technical-list">
            <li>Distruzione del core</li>
            <li>Eliminazioni e vite</li>
            <li>Risorse/Token in partita</li>
            <li>NO CANNONI AUTOMATICI</li>
          </ul>
        </Panel>
        <Panel eyebrow="Stagioni" title="Soft reset">
          <p>
            Al cambio stagione il rating precedente pesa al 75%, mentre la
            baseline iniziale pesa al 25%. I placement ripartono da zero.
          </p>
        </Panel>
      </section>

      <section className="section">
        <header className="section-heading">
          <p className="eyebrow">22 gradi reali</p>
          <h2>Dalla lega Bronzo a TNT Legend.</h2>
        </header>
        <div className="rank-grid">
          {rankFamilies.map((family, index) => (
            <article className="rank-tier" key={family.name}>
              <span>{String(index + 1).padStart(2, '0')}</span>
              <div className="rank-tier__emblems">
                {family.ranks.map((rank) => (
                  <RankEmblem
                    key={rank.id}
                    label={rank.name}
                    rankId={rank.id}
                    size="large"
                  />
                ))}
              </div>
              <h3>{family.name}</h3>
              <p>{family.range}</p>
            </article>
          ))}
        </div>
      </section>
    </main>
  )
}
